import { Injectable } from '@angular/core';

import { CustomerAddress } from '../../../customer/model/customer-information.model';
import { TolerantPostFCCityStreetNumberQueryOptions } from '../model/request.model';

@Injectable({
  providedIn: 'root',
})
export class TolerantPostRequestModelMapper {
  map(
    address: CustomerAddress,
    reqId?: string,
    language?: string,
    maxResultCount = 10,
  ): TolerantPostFCCityStreetNumberQueryOptions {
    const country = address.country;
    if (!country) {
      throw new Error(
        '#CDFTF0023 Customer has no country information. Country information is required to query Tolerant Post.',
      );
    }

    return {
      reqId: reqId ?? '',
      maxResultCount: maxResultCount ?? '',
      street: address.street ?? '',
      number: address.houseNumber ?? '',
      addressline2: '',
      addressline3: '',
      postalcode: address.postalCode ?? '',
      city: address.city ?? '',
      province: address.province ?? '',
      country: country,
      singleLine: '',
      language: language ?? '',
      pobox: '',
    };
  }
}
